import React from 'react'

export default function BooleanField({
  label,
  name,
  defaultValue,
  value,
  onChange,
  error,
  className = '',
  yesLabel = 'Sim',
  noLabel = 'Não'
}) {
  const isControlled = value !== undefined
  const currentValue = isControlled ? value : defaultValue

  const handleChange = (newValue) => {
    if (onChange) {
      onChange(newValue)
    }
  }

  return (
    <div className={`mb-4 ${className}`}>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
      </label>
      <div className="flex gap-6">
        <label className="inline-flex items-center cursor-pointer">
          <input
            type="radio"
            name={name}
            value="true"
            checked={isControlled ? currentValue === true : undefined}
            defaultChecked={!isControlled && (currentValue === true || currentValue === 'true')}
            onChange={() => handleChange(true)}
            className="w-4 h-4 text-brand-light focus:ring-brand-light border-gray-300"
          />
          <span className="ml-2 text-sm text-gray-700">{yesLabel}</span>
        </label>
        <label className="inline-flex items-center cursor-pointer">
          <input
            type="radio"
            name={name}
            value="false"
            checked={isControlled ? currentValue === false : undefined}
            defaultChecked={!isControlled && (currentValue === false || currentValue === 'false')}
            onChange={() => handleChange(false)}
            className="w-4 h-4 text-brand-light focus:ring-brand-light border-gray-300"
          />
          <span className="ml-2 text-sm text-gray-700">{noLabel}</span>
        </label>
      </div>
      {error && (
        <div className="mt-1 text-red-600 text-sm">{error}</div>
      )}
    </div>
  )
}
